//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryProjectManagerByParams } from '@/api/pm/project';

export default {
	data() {
		return {
			projectManager: [], //所有的项目类型数量总览
			projTypeCode: this.$route.params.projTypeCode,
			respDeptCode: this.$route.params.respDeptCode,
		}
	},
	created() {

	},
	computed: {},
	mounted: function() {
		this.loadProjectManagerByParams();
	},
	methods: {
		// 返回
		goback() {
			// 返回工作台
			this.$router.push({
				name: '立项总览'
			});
		},
		//根据条件获取每种项目类型的项目数量
		loadProjectManagerByParams() {
			var queryParams = {
				projTypeCode: this.projTypeCode,
				respDeptCode: this.respDeptCode
			}
			var condition = {
				'condition': JSON.stringify(queryParams)
			};
			queryProjectManagerByParams(condition).then(response => {
				// 数据赋值
				for(let i = 0; i < response.length; i++) {
					this.projectManager.push(response[i]);
				}
			});
		},
		//进入列表信息
		loadListData(pmCode) {
			// 参数一：项目经理编码    
			this.$router.push({
				name: '立项列表',
				params: {
					gobackName: '立项总览',
					projTypeCode: this.projTypeCode,
					respDeptCode: this.respDeptCode,
					pmCode:pmCode
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/view/pm/project/projectManager.vue